import axios from '@/tools/axios/axios'
import ClientGraphql, { getOperationName } from '@/tools/client-graphql'
import { getEndpointModifierForOperation } from '@/tools/endpoint-modifier'
import { querySearchAutocompleteForProducts } from '@/web/queries/search-autocomplete-for-products'
import { querySearchAutocompleteForUsers } from '@/web/queries/search-autocomplete-for-users'

const QUERY_BY_CONTEXT = {
  users: querySearchAutocompleteForUsers,
  products: querySearchAutocompleteForProducts,
  all: querySearchAutocompleteForProducts
}

export default class SearchAutocomplete {
  constructor(endpoint) {
    this.clientGraphql = new ClientGraphql({ endpoint })
    this.cancelRequestToken = null
  }

  fetch({ variables = {}, context = '' } = {}) {
    let query
    let cancelToken
    let endpointModifier

    if (!context) return new Promise((resolve, reject) => reject(new Error('Context missing')))

    if (this.cancelRequestToken) {
      this.cancelRequestToken.cancel()
      this.cancelRequestToken = null
    }

    this.cancelRequestToken = axios.CancelToken.source()

    query = QUERY_BY_CONTEXT[context]

    if (!query) return new Promise((resolve, reject) => reject(new Error('Query missing')))

    endpointModifier = getEndpointModifierForOperation(getOperationName(query))
    cancelToken = this.cancelRequestToken.token

    return this.clientGraphql
      .fetch({ query, variables, endpointModifier, cancelToken })
      .then(response => {
        this.cancelRequestToken = null
        return response
      })
  }
}
